// extracted by mini-css-extract-plugin
export default {"thanksBox":"index_thanksBox_ChVwo","thanksPic":"index_thanksPic_yZHkW"};